var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"sm-checkbox",class:'sm-checkbox--' + _vm.type},[_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }